import axios from 'axios'

const mode = process.env.REACT_APP_MODE
console.log(mode)

// const mode = 'dev';
// const mode = 'dev';
// const proxyurl = "https://cors-anywhere.herokuapp.com/";

const urlLocal = process.env.REACT_APP_URL_LOCAL
// const urlDev = 'http://apis-bo-demo.payboard.cc/backoffice/';
const urlDev = process.env.REACT_APP_URL_DEV
const urlPrd = process.env.REACT_APP_URL_PRD


let baseURL
let baseURLApp
if (mode == 'local') {
  baseURL = `${urlLocal}`
} else if (mode == 'dev') {
  baseURL = `${urlDev}`
} else if (mode == 'pro') {
  baseURL = `${urlPrd}`
}

export default axios.create({
  baseURL: baseURL,
  responseType: 'json'
})

export const auth = {
  'Content-Type': 'application/json',
  Authorization: process.env.REACT_APP_API_AUTH
  // 'crossorigin':true
}

export const authApp = {
  'Content-Type': 'application/json',
  Authorization: process.env.REACT_APP_API_AUTH_APP
  // 'crossorigin':true
}

export const apiUrl = baseURL

export const apikey = process.env.REACT_APP_API_KEY
